// @flow
import { ResourceResponseContext } from 'components/ResourceFill/providers/ResourceResponseProvider'
import { ResourceSessionsContext } from 'components/ResourceFill/providers/ResourceSessionsProvider'
import { ResourceSharedContext } from 'components/ResourceFill/providers/ResourceSharedProvider'
import * as React from 'react'
import type { Form } from 'types/form'
import type { Packet } from 'types/packet'

function useResource(): void | Form | Packet {
  const { isPacket } = React.useContext(ResourceSharedContext) || {}

  const { currentSession } = React.useContext(ResourceSessionsContext) || {}

  const { response } = React.useContext(ResourceResponseContext) || {}

  return React.useMemo(
    () => (isPacket ? currentSession?.packetResponse?.packet : response?.form),
    [currentSession?.packetResponse?.packet, isPacket, response?.form]
  )
}

export default useResource
